export const capitalize = (string) => string.charAt(0).toUpperCase() + string.slice(1);
export const convertFirstNUppercased = (str, n = 1) =>
  str
    .slice(0, n)
    .split('')
    .map((ch) => ch.toUpperCase())
    .join('') + str.slice(n);

export default { capitalize, convertFirstNUppercased };
